// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  ICianApiSiteV1AdfoxHomeRequest,
  TCianApiSiteV1AdfoxHomeModel,
  IMappers,
  TCianApiSiteV1AdfoxHomeResponse,
  TCianApiSiteV1AdfoxHomeResponse_1,
  TCianApiSiteV1AdfoxHomeResponseError,
  TCianApiSiteV1AdfoxHome404,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createCianApiSiteV1AdfoxHomeModel(
  parameters: ICianApiSiteV1AdfoxHomeRequest,
): TCianApiSiteV1AdfoxHomeModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'GET',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/adfox/home/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
      404: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface ICianApiSiteV1AdfoxHomeOptions<TResponse200, TResponse400, TResponse404> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400, TResponse404>;
  parameters: ICianApiSiteV1AdfoxHomeRequest;
}

export async function fetchCianApiSiteV1AdfoxHome<TResponse200, TResponse400, TResponse404>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1AdfoxHomeOptions<TResponse200, TResponse400, TResponse404>): Promise<
  FetchResponse<TCianApiSiteV1AdfoxHomeResponse> | TResponse200 | TResponse400 | TResponse404
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1AdfoxHomeModel(parameters),
    config,
  )) as FetchResponse<TCianApiSiteV1AdfoxHomeResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TCianApiSiteV1AdfoxHomeResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TCianApiSiteV1AdfoxHomeResponseError, headers);
    }
    if (statusCode === 404) {
      return mappers[404](response as TCianApiSiteV1AdfoxHome404, headers);
    }
  }

  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1AdfoxHomeResponse>;
}
